var api = require("!../../../../../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ref--10-1!../../../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ref--10-2!./RegisterGoogleDetail.module.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};